import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../lib/analytics';

/**
 * One analytics page view per route; a query or hash change is not a new page. Rendered once
 * inside <Router>, after the routes, so the page view carries the title the page just set.
 * An app sign-in's path carries its interaction id, a sign-in in progress; Google gets the route
 * without it.
 */
const PageViews: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => trackPageView(pathname.replace(/^\/oauth\/interaction\/.*$/, '/oauth/interaction')), [pathname]);

  return null;
};

export default PageViews;
